import { useEffect, useRef, useState } from "react";
import { Volume2, Pause, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { API } from "@/lib/api";

export default function ListenButton({ qaId }) {
  const audioRef = useRef(null);
  const [state, setState] = useState("idle"); // idle | loading | playing | paused

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const toggle = async () => {
    if (state === "playing") {
      audioRef.current?.pause();
      setState("paused");
      return;
    }
    if (state === "paused" && audioRef.current) {
      audioRef.current.play();
      setState("playing");
      return;
    }
    // first play
    setState("loading");
    const audio = new Audio(`${API}/answer/${qaId}/audio.mp3`);
    audioRef.current = audio;
    audio.onended = () => setState("idle");
    audio.onerror = () => {
      setState("idle");
      toast.error("The narration could not be played.");
    };
    try {
      await audio.play();
      setState("playing");
    } catch {
      setState("idle");
      toast.error("The narration could not be played.");
    }
  };

  return (
    <Button
      data-testid="listen-button"
      onClick={toggle}
      variant="outline"
      className="rounded-full font-sans"
    >
      {state === "loading" && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {state === "playing" && <Pause className="mr-2 h-4 w-4" />}
      {(state === "idle" || state === "paused") && <Volume2 className="mr-2 h-4 w-4" />}
      {state === "loading" ? "Preparing..." : state === "playing" ? "Pause" : state === "paused" ? "Resume" : "Listen"}
    </Button>
  );
}
